import { ChartOption } from '../types/chart-option.types';

// -----------------------------------------------------------------------------
export const weightForLengthOptions: ChartOption[] = [
  {
    id: 'weight-for-length-0-2',
    displayName: '0-2 years (45-110cm)',
    datasetId: {
      male: 'who-boys-weight-for-length-0-2',
      female: 'who-girls-weight-for-length-0-2',
    },
    lengthFilter: (length) => length >= 45 && length <= 110,
    measurementType: 'weight_for_length',
  },
  {
    id: 'weight-for-length-2-5',
    displayName: '2-5 years (65-120cm)',
    datasetId: {
      male: 'who-boys-weight-for-length-2-5',
      female: 'who-girls-weight-for-length-2-5',
    },
    lengthFilter: (length) => length >= 65 && length <= 120,
    measurementType: 'weight_for_length',
  },
];
